<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"></rappider-title-toolbar>

<section class="project-members">
  <rappider-list-grid [config]="PROJECT_MEMBERS_CONFIG"
                      [data]="members"
                      [loading]="loading"
                      (columnActionClick)="onColumnActionClick($event)"></rappider-list-grid>
</section>
